import * as React from "react";

export class Row extends React.Component<{
    classes?: string;
    isHidden?: boolean;
}, {}> {
    render() {
        return (
            <tr className={this.props.classes} hidden={this.props.isHidden}>
                {this.props.children}
            </tr>
        );
    }
}
